"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('setIsSaving', function setIsSaving(newValue) {
    store_1.getStore().isSaving = newValue;
});
//# sourceMappingURL=setIsSaving.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/mutators/setIsSaving.js
// module id = 4914
// module chunks = 2